import { render } from "./Activity.vue?vue&type=template&id=3ddb088f&ts=true"
import script from "./Activity.vue?vue&type=script&lang=ts"
export * from "./Activity.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__